import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=2e98e394&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=2e98e394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98e394",
  null
  
)

export default component.exports